// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1Gg3K","title":"ClientCherryInfo_title__220qq","itemText":"ClientCherryInfo_itemText__8Y4z8"};